/** Scroll the window to the top (used on navigation and repeat link clicks). */
export function scrollToTop() {
  const apply = () => {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }
  apply()
  requestAnimationFrame(apply)
}
